import { getCountryFromLanguage } from '../Intl/IntlHelper.js';

// Delivery carriers surfaced per country.
// Colissimo (La Poste), Mondial Relay and STEF ship to every locale; each
// other country also shows its national / assigned carrier.
//
// Tile logos live in assets/images/shippings/tiles/{key}.{webp,png}

export const CARRIER_LABELS = {
    colissimo: 'Colissimo',
    'mondial-relay': 'Mondial Relay',
    stef: 'STEF',
    dpd: 'DPD',
    postnl: 'PostNL',
    'poste-italiane': 'Poste Italiane',
    correos: 'Correos',
    'royal-mail': 'Royal Mail',
};

// Available for every supported locale.
const COMMON = ['colissimo', 'mondial-relay', 'stef'];

// National / assigned carrier(s) appended per customer country.
const BY_COUNTRY = {
    DE: [...COMMON, 'dpd'],
    NL: [...COMMON, 'postnl', 'dpd'],
    IT: [...COMMON, 'poste-italiane'],
    ES: [...COMMON, 'correos'],
    GB: [...COMMON, 'royal-mail'],
    // FR falls back to COMMON (Colissimo is its national carrier)
};

export function getCarriersForLocale(locale) {
    const country = getCountryFromLanguage(locale);
    return BY_COUNTRY[country] || COMMON;
}
